import { IIconProps } from './types';

/**
 * -----------------------------------------------------------------------------
 * It renders a bundle of money like shape.
 */
export function MoneyIcon({
  className,
  strokeWidth = 1,
  variant,
}: Readonly<IIconProps>) {
  if (variant !== 'solid') {
    return (
      <svg className={className} fill="none" viewBox="0 0 24 24">
        <path
          d="M4 8h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2Z"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
        />
        <path
          d="M13.768 13.232a2.5 2.5 0 1 1-3.536 3.536 2.5 2.5 0 0 1 3.536-3.536M18 17.5v-5M6 17.5v-5M20 5H4M19 2H5"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
        />
      </svg>
    );
  }

  return (
    <svg className={className} viewBox="0 0 24 24">
      <path d="M20 6.9H4c-1.5 0-2.8 1.2-2.8 2.8v10c0 1.5 1.2 2.8 2.8 2.8h16c1.5 0 2.8-1.2 2.8-2.8v-10c0-1.5-1.2-2.8-2.8-2.8ZM6.8 17.1c0 .4-.3.8-.8.8s-.8-.3-.8-.8v-5c0-.4.3-.8.8-.8s.8.3.8.8v5Zm7.5-.2c-.6.6-1.4 1-2.3 1-.9 0-1.7-.3-2.3-1-1.3-1.3-1.3-3.3 0-4.6 1.2-1.2 3.4-1.2 4.6 0 1.3 1.3 1.3 3.3 0 4.6Zm4.5.2c0 .4-.3.8-.8.8s-.8-.3-.8-.8v-5c0-.4.3-.8.8-.8s.8.3.8.8v5Z" />
      <path
        d="M20 4.6H4M19 1.6H5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}
